import React from 'react';
import Carousel from 'components/carousel/Carousel';
import WidgetFrame from 'components/widget-frame/WidgetFrameNew';

class CarouselWidget extends React.Component {
    constructor(props) {
        super(props);

        const _unit = props.unit;

        let data = [];
        if (typeof props.data !== 'undefined' && Object.keys(props.data).length > 0) {
            if (typeof props.defaultKey1 !== 'undefined' && typeof props.defaultKey2 !== 'undefined') {
                data = props.data[props.defaultKey1][props.defaultKey2]['data'];
            }
        }

        this.state = {
            data: data,
            unit: _unit
        };
    }

    updateWidgetData = (newData) => {
        this.setState({
            data: newData.data,
            unit: newData.unit
        });
    };

    render() {
        return (
            <WidgetFrame
                type="carousel"
                page={this.props.page}
                pageName={this.props.pageName}
                data={this.props.data}
                loading={this.props.loading}
                title={this.props.title}
                updateData={this.updateWidgetData}
                showTabs={false}
                showOverflow={true}
                dataObject={this.props.dataObject}
                dd1Options={this.props.dd1Options}
                workbench_type={this.props.workbench_type || ''}
                tenantIcaoCode={this.props.tenantIcaoCode || ''}
                appliedFilters={this.props.appliedFilters}
                app={this.props.app}
                dataAvailable={this.state.data && this.state.data.length !== 0 ? true : false}
                contentType={this.props.contentType}
                body={
                    <Carousel
                        page={this.props.page}
                        type={this.props.type}
                        data={this.state.data}
                        unit={this.state.unit || 'hr'}
                        loading={this.props.loading}
                        appliedFilters={this.props.appliedFilters}
                        contentType={this.props.contentType}
                        app={this.props.app}
                        title={this.props.title}
                    />
                }
            />
        );
    }
}

export default CarouselWidget;
